import React from 'react';
import { Card } from '../ui/Card';
import { Wallet, Globe, CreditCard, TrendingUp } from 'lucide-react';
export function Features() {
  const features = [{
    title: 'Global Wallets',
    description: 'Get local account details for USD, EUR, GBP, and more.',
    icon: Wallet
  }, {
    title: 'International Transfers',
    description: 'Send money like a local, anywhere in the world.',
    icon: Globe
  }, {
    title: 'Spending & Cards',
    description: 'Spend your balance anywhere Visa is accepted.',
    icon: CreditCard
  }, {
    title: 'Savings & Yield',
    description: 'Access DeFi yields with a simple, secure interface.',
    icon: TrendingUp
  }];
  return <section className="py-24 bg-slate-50" data-id="element-232">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-233">
        <div className="text-center mb-16" data-id="element-234">
          <h2 className="text-3xl font-bold text-slate-900 mb-4" data-id="element-235">
            Everything you need
          </h2>
          <p className="text-lg text-slate-600" data-id="element-236">
            A complete financial toolkit for the global citizen.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-237">
          {features.map(feature => <Card key={feature.title} className="flex items-start p-8" data-id="element-238">
              <div className="w-12 h-12 rounded-full bg-blue-100 text-blue-600 flex items-center justify-center shrink-0 mr-6" data-id="element-239">
                <feature.icon className="w-6 h-6" data-id="element-240" />
              </div>
              <div data-id="element-241">
                <h3 className="text-xl font-semibold text-slate-900 mb-2" data-id="element-242">
                  {feature.title}
                </h3>
                <p className="text-slate-600" data-id="element-243">{feature.description}</p>
              </div>
            </Card>)}
        </div>
      </div>
    </section>;
}